import {
  PAYMENT_TYPE_AMEX,
  PAYMENT_TYPE_DINERS,
  PAYMENT_TYPE_DISCOVER,
  PAYMENT_TYPE_MC,
  PAYMENT_TYPE_VISA,
  PAYMENT_TYPE_STAR,
  PAYMENT_TYPE_NYCE,
  PAYMENT_TYPE_PULSE,
} from 'webapp-common-ui/src/constants';

export default function paymentTypeToCreditCardType(paymentType) {
  switch (paymentType) {
    case PAYMENT_TYPE_AMEX:
      return 'AMEX';

    case PAYMENT_TYPE_DINERS:
      return 'DINERS';

    case PAYMENT_TYPE_DISCOVER:
      return 'DISCOVER_NETWORK';

    case PAYMENT_TYPE_MC:
      return 'MC';

    case PAYMENT_TYPE_VISA:
      return 'VISA';

    case PAYMENT_TYPE_STAR:
      return 'STAR';

    case PAYMENT_TYPE_NYCE:
      return 'NYCE';

    case PAYMENT_TYPE_PULSE:
      return 'PULSE';

    default:
      return null;
  }
}